/* eslint-disable prefer-const */
/**
 * Profile
 * @type {boolean}
 */
export let debug = process.env.NODE_ENV === 'development';
